import type { ManufacturerCategory as ApiManufacturerCategory } from "randmar-api-client";
import { OrderDetail } from "../document/Document";
import { InventoryValue } from "../manufacturer/Manufacturer";
import { Product } from "../product/Product";

export class Category {

  public categoryName?: string;
  public categoryCode?: string;
  public niche?: string;
  /** @deprecated use aGp instead */
  public a_gp?: number;
  public aGp?: number;
  /** @deprecated use bGp instead */
  public b_gp?: number;
  public bGp?: number;
  /** @deprecated use cGp instead */
  public c_gp?: number;
  public cGp?: number;
  /** @deprecated use dGp instead */
  public d_gp?: number;
  public dGp?: number;
  /** @deprecated use costGp instead */
  public cost_gp?: number;
  public costGp?: number;
  public leadTime?: string;
  public minimumOrder?: string;
  public weeksOfStocking?: string;
  public inventoryValue?: InventoryValue[];
  public products?: Product[];
  public openOrders?: OrderDetail[];
  public starred?: boolean;
  public autoReorder?: boolean;
  public qualificationRequired?: boolean;

  public static convertFrom(source: ApiManufacturerCategory): Category {
    const category = new Category();

    category.categoryName = source.CategoryName ?? undefined;
    category.categoryCode = source.CategoryCode ?? undefined;
    category.niche = source.Niche ?? undefined;
    category.a_gp = source.A_GP ?? undefined;
    category.aGp = source.A_GP ?? undefined;
    category.b_gp = source.B_GP ?? undefined;
    category.bGp = source.B_GP ?? undefined;
    category.c_gp = source.C_GP ?? undefined;
    category.cGp = source.C_GP ?? undefined;
    category.d_gp = source.D_GP ?? undefined;
    category.dGp = source.D_GP ?? undefined;
    category.cost_gp = source.Cost_GP ?? undefined;
    category.costGp = source.Cost_GP ?? undefined;
    category.leadTime = source.LeadTime !== undefined && source.LeadTime !== null ? String(source.LeadTime) : undefined;
    category.minimumOrder =
      source.MinimumOrder !== undefined && source.MinimumOrder !== null ? String(source.MinimumOrder) : undefined;
    category.weeksOfStocking =
      source.WeeksOfStocking !== undefined && source.WeeksOfStocking !== null ? String(source.WeeksOfStocking) : undefined;
    category.starred = source.Starred;
    category.autoReorder = source.AutoReorder;
    category.qualificationRequired = source.QualificationRequired;

    if (source.InventoryValue)
      category.inventoryValue = source.InventoryValue.map(InventoryValue.convertFrom);

    if (source.Products)
      category.products = source.Products.map(Product.convertFromNewProduct);

    if (source.ActiveOrderDetails)
      category.openOrders = source.ActiveOrderDetails.map(OrderDetail.convertFromApi);

    return category;
  }
}
